import { get } from 'lodash';

export class LinkBankFormErrorModel {
    constructor() {
        this.formError = null;
        this.flattenedErrors = {
            accountId: {},
            accountName: {},
            birthDate: {},
            accountAddress: {},
            citizenship: {},
            bankCode: {},
            bankName: {},
            bankAddress: {},
            parent: {}
        };
        this.hasError = true;
        this.errorMessage = {
            title: 'Warning',
            body: 'Something went wrong. Please try again later.',
        };
    }

    setFormErrors(errors) {
        this.flattenedErrors.parent = get(errors, 'errors');
        this.flattenedErrors.accountId = get(errors, 'children.account_id.errors');
        this.flattenedErrors.accountName = get(errors, 'children.account_name.errors');
        this.flattenedErrors.birthDate = get(errors, 'children.birth_date.errors');
        this.flattenedErrors.citizenship = get(errors, 'children.citizenship.errors');
        this.flattenedErrors.accountAddress = get(errors, 'children.account_address.errors');
        this.flattenedErrors.bankCode = get(errors, 'children.swift_code.errors');
        this.flattenedErrors.bankName = get(errors, 'children.bank_name.errors');
        this.flattenedErrors.bankAddress = get(errors, 'children.bank_address.errors');
    }

    clearFormErrors() {
        this.flattenedErrors = {
            accountId: {},
            accountName: {},
            birthDate: {},
            accountAddress: {},
            citizenship: {},
            bankCode: {},
            bankName: {},
            bankAddress: {},
            parent: {}
        };
    }

    get accountId() {
        return this.flattenedErrors['accountId'];
    }

    get accountName() {
        return this.flattenedErrors['accountName'];
    }

    get birthDate() {
        return this.flattenedErrors['birthDate'];
    }

    get citizenship() {
        return this.flattenedErrors['citizenship'];
    }

    get accountAddress() {
        return this.flattenedErrors['accountAddress'];
    }

    get bankCode() {
        return this.flattenedErrors['bankCode'];
    }

    get bankName() {
        return this.flattenedErrors['bankName'];
    }

    get bankAddress() {
        return this.flattenedErrors['bankAddress'];
    }

    get parent() {
        return this.flattenedErrors['parent'];
    }
}

export default LinkBankFormErrorModel;



// WEBPACK FOOTER //
// ./client/app/shared/system-components/link-bank-widget/model/form-error.model.js